(function () {
  if (customElements.get('bm-walkthrough')) return;

  class BmWalkthrough extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('[data-bmw-open]');
      this.modal = this.querySelector('[data-bmw-modal]');
      if (!this.trigger || !this.modal) return;

      this.closers = this.modal.querySelectorAll('[data-bmw-close]');
      this.video = this.modal.querySelector('[data-bmw-video]');
      this.iframe = this.modal.querySelector('[data-bmw-iframe]');

      this.onKeydown = this.onKeydown.bind(this);

      this.trigger.addEventListener('click', () => this.open());
      this.closers.forEach((el) => el.addEventListener('click', () => this.close()));
    }

    open() {
      this.modal.hidden = false;
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', this.onKeydown);

      if (this.iframe && this.iframe.dataset.src) {
        this.iframe.src = this.iframe.dataset.src;
      }
      if (this.video) {
        try {
          this.video.play();
        } catch (e) {}
      }

      this.modal.querySelector('.bmw-modal__close')?.focus();
    }

    close() {
      this.modal.hidden = true;
      document.body.style.overflow = '';
      document.removeEventListener('keydown', this.onKeydown);

      if (this.iframe) {
        this.iframe.src = 'about:blank';
      }
      if (this.video) {
        this.video.pause();
        this.video.currentTime = 0;
      }

      this.trigger.focus();
    }

    onKeydown(event) {
      if (event.key === 'Escape') this.close();
    }
  }

  customElements.define('bm-walkthrough', BmWalkthrough);
})();
